module.exports = __webpack_public_path__ + "img/雾.3d284789.png";